module.exports = __webpack_public_path__ + "static/media/vf_mshirts_core.75d77ea7.svg";